import type { IngestionAnalyseEstimateRes } from '@dealstack/shared/lib/generated';
import type { TranslationRef } from '../../AnalysisWorkspace/components/primitives/primitives.types';
import { etaCopy } from '../useBatchProcessing/useBatchProcessing.utils';
import type { AnalyseEstimateView } from './useExtractFromDocumentModalController.types';

const readersNote = (readersRunning: boolean | null): TranslationRef | null => {
	if (readersRunning === null) {
		return { key: 'dealstack_ai.ingest.confirm.readers_unknown' };
	}
	return readersRunning ? null : { key: 'dealstack_ai.ingest.confirm.readers_starting' };
};

/** The confirm's figures, straight from the estimate; what the server could not know is said, not filled in. */
export const toAnalyseEstimateView = (
	estimate: IngestionAnalyseEstimateRes
): AnalyseEstimateView => {
	const notes: TranslationRef[] = [];
	const readers = readersNote(estimate.readersRunning);
	if (estimate.firstBatchEta === null) {
		notes.push({ key: 'dealstack_ai.ingest.confirm.no_time' });
	} else if (readers !== null) {
		notes.push(readers);
	}

	return {
		documents: estimate.documents,
		pages: estimate.pagesTotal,
		time: estimate.firstBatchEta === null ? null : etaCopy(estimate.firstBatchEta),
		notes,
	};
};
